import script from "./newBackup.vue?vue&type=script&setup=true&lang=js"
export * from "./newBackup.vue?vue&type=script&setup=true&lang=js"

import "./newBackup.vue?vue&type=style&index=0&id=1cc3cffa&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc3cffa"]])

export default __exports__